import { render, staticRenderFns } from "./SchemaView.vue?vue&type=template&id=04e5c71d&"
import script from "./SchemaView.vue?vue&type=script&lang=ts&"
export * from "./SchemaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports